"use client";

import { c as _c } from "react/compiler-runtime";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
interface Props {
  isEnabled: boolean;
}
export function DraftModeBanner(t0) {
  const $ = _c(8);
  const {
    isEnabled
  } = t0;
  const pathname = usePathname();
  const [isInIframe, setIsInIframe] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsInIframe(window.self !== window.top);
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isEnabled) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="flex items-center gap-2"><IconEye size={16} />Draft mode — you are viewing unpublished content</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isInIframe || $[4] !== pathname) {
    t4 = !isInIframe && <Button variant="outline" size="sm" className="border-amber-950/30 bg-transparent text-amber-950 hover:bg-amber-500" asChild={true}><a href={`/api/draft/disable?slug=${pathname.replace(/^\//, "")}`}><IconEyeOff size={14} />Go to live view</a></Button>;
    $[3] = isInIframe;
    $[4] = pathname;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="sticky top-0 z-50 flex items-center justify-between gap-4 bg-amber-400 px-4 py-2 text-sm font-medium text-amber-950">{t3}{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}